/* eslint-disable import/prefer-default-export */
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../form-fields.module.css';

interface InputTextAreaProps {
    id: string;
    name: string;
    value: string;
    handler: (e: React.FormEvent<HTMLTextAreaElement>) => void;
    required?: boolean;
    formRow?: boolean;
    hidden?: boolean;
}

export const TextArea: React.FC<InputTextAreaProps> = ({
    id,
    name,
    value,
    handler,
    required = false,
    formRow = false,
    hidden = false,
}) => {
    const { t } = useTranslation(['common']);

    return (
        <>
            <label
                className={`${styles.InputElementLabel} ${hidden ? styles.Hidden : ''}`}
                htmlFor={id}
                data-qa={`text-area-label-${id}`}
            >{`${name} ${required ? `(${t('common:required')})` : ''}`}</label>
            <textarea
                className={`${styles.InputElement} ${styles.TextAreaInput} ${formRow ? styles.FormRow : ''} ${
                    hidden ? styles.Hidden : ''
                }`}
                id={id}
                name={name}
                value={value}
                onChange={handler}
                required={required}
                rows={5}
                data-qa={`form-field-text-area-${id}`}
            />
        </>
    );
};
